import React, { useState, useEffect, useRef } from 'react';

function TodoForm(props) {
    const [input, setInput] = useState([props.edit ? props.edit.value : '']);

    const inputRef = useRef(null);

    useEffect(() => {
      inputRef.current.focus();
    });

    const handleSubmit = event => {
      event.preventDefault();
      props.onSubmit({
          id: Math.floor(Math.random() * 1000000),
          text: input
      });
      
      setInput("");
    };

    const handleChange = event => {
        setInput(event.target.value);
    };

    return (
        <form onSubmit={handleSubmit} className='todo-form'>
          {props.edit ? (
            <>
                <input
                placeholder='Update your item'
                value={input}
                onChange={handleChange}
                name='text'
                ref={inputRef}
                className='todo-input edit'
              />
              <button onClick={handleSubmit} className='todo-button edit'>
                Update
              </button>
            </>
          ) : (
            <>
              <input
                placeholder='Add a task'
                value={input}
                onChange={handleChange}
                name='text'
                className='todo-input'
                ref={inputRef}
              />
              <button onClick={handleSubmit} className='todo-button'>
                Add task
              </button>
            </>
          )}
        </form>
      );
}

export default TodoForm;
